export default __webpack_public_path__ + "static/star-history-7f36f275a4c463ee341a3a867b2db8ac.png";